<template>
    <div class="">
        <div class="mb-4">
            <span class="text-sm font-bold text-gray-500">06.</span>
        </div>
        <div class="mb-4">
            <span class="text-5xl font-extrabold tracking-tight">Deurtrekker.</span>
        </div>
        <div class="mb-4">
            <span class="text-xl font-extrabold tracking-tight">Soorten</span>
        </div>
        <div class="grid grid-cols-3 gap-2 mb-8 lg:grid-cols-4 xl:gap-4 xl:grid-cols-3"> 
            <div
                v-for="(doorHandleType, index) in doorHandleTypes"
                :key="index"
            >
                <div
                    class="pl-4 transition duration-300 ease-in-out border-l-4 border-transparent group hover:border-black"
                    @click="setDoorHandleType()"
                    :id="doorHandleTypes[index].type"
                    :class="$store.state.doorHandleType === doorHandleTypes[index].type ? ['border-black', 'text-black'] : ['border-transparent', 'text-gray-500']"
                >
                    <img
                        :src="doorHandleTypes[index].image"
                        class="w-32 transition duration-300 ease-in-out cursor-pointer group-hover:text-black"
                        alt="scharnierdeur"
                    >
                    <span
                        class="tracking-wider transition duration-300 ease-in-out cursor-pointer group-hover:text-black"
                    >
                        {{  doorHandleTypes[index].typeNl }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapMutations } from 'vuex'

    export default {
        data() {
            return {
                doorHandleTypes: [
                    { 
                        id: 1,
                        type: 'levem',
                        typeNl: 'Levem',
                        image: require('../../assets/images/deurtrekkers/1.jpg')
                    },
                    { 
                        id: 2,
                        type: 'garcia',
                        typeNl: 'Garcia',
                        image: require('../../assets/images/deurtrekkers/2.jpg')
                    },
                    { 
                        id: 3,
                        type: 'loft',
                        typeNl: 'Loft',
                        image: require('../../assets/images/deurtrekkers/3.jpg')
                    },
                    { 
                        id: 4,
                        type: 'secret-grip',
                        typeNl: 'Secret',
                        image: require('../../assets/images/deurtrekkers/4.jpg')
                    },
                    { 
                        id: 5,
                        type: 'circo',
                        typeNl: 'Circo',
                        image: require('../../assets/images/deurtrekkers/5.jpg')
                    },
                    { 
                        id: 6,
                        type: 'Qubis',
                        typeNl: 'Qubis',
                        image: require('../../assets/images/deurtrekkers/6.jpg')
                    },
                    { 
                        id: 7,
                        type: 'planus',
                        typeNl: 'Planus',
                        image: require('../../assets/images/deurtrekkers/7.jpg')
                    },
                ],
            }
        },
        methods: {
            ...mapMutations([
                'setDoorHandleType'
            ]),
        },
        computed: {
            ...mapState([
                'doorHandleType'
            ]), 
        },
    }
    
</script>
    
<style>

</style>